import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';

export const useEmailProcessingDialogStyles = createStyles(({ token }) => ({
  // `&&` outranks SimpleDialog.styles.js's base `.ant-modal-content`/
  // `.ant-modal-body`/typography rules (equal specificity otherwise, since
  // both are applied directly to the same Modal).
  emailProcessingDialog: {
    '&&': {
      '.ant-modal-content': {
        [`@media (min-width: ${token.screenMDMin}px)`]: {
          width: '460px !important',
        },
      },

      '.ant-modal-body': {
        alignItems: 'center',

        [`@media (min-width: ${token.screenMDMin}px)`]: {
          padding: `35px ${ThemeSpaces.SPACE_NORM}px`,
        },
        [`@media (max-width: ${token.screenSMMax}px)`]: {
          padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,
        },

        'h1.ant-typography': {
          lineHeight: 1,
          fontSize: ThemeFont.FONT_SIZE_30,
          marginTop: ThemeSpaces.SPACE_SM,
          marginBottom: ThemeSpaces.SPACE_LG,
          color: ThemeColors.COLOR_GREY2,
        },
        'h4.ant-typography': {
          fontWeight: 'normal',
          textAlign: 'center',
          color: ThemeColors.COLOR_GREY2,
        },
      },
    },
  },
}));
